import { Col, Form, Row } from "antd";
import React from "react";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import dayjs from "dayjs";
import { ListaPreciosTabContentTable } from "./ListaPreciosTabContentTable";
import { useSelector } from "react-redux";
const itemDefault = {
  id: 0,
  listaprecio: null,
  precio: null,
};
export const ListaPreciosTabContent = () => {
  const { activeProducto } = useSelector((state) => state.producto);
  return (
    <Row>
      <Col xs={24} sm={24} md={24} lg={24} xl={16} xxl={12}>
        <Form.List
          name="itemlistaprecios"
          rules={[
            {
              validator: async (_, value) => {
                if (activeProducto !== null) {
                  // Editar producto
                  if (!value || value.length < 1)
                    return Promise.reject(
                      new Error(
                        "Ingrese al menos un item en la lista de precios"
                      )
                    );
                }
              },
            },
          ]}
        >
          {(fields, { add, remove }, { errors }) => (
            <>
              <ListaPreciosTabContentTable
                data={fields}
                handleDelete={remove}
                title={() => (
                  <ButtonUi
                    typeUi={TipoButtonConstants.AgregarTable}
                    onClick={() =>
                      add({ ...itemDefault, id: dayjs().valueOf() })
                    }
                  />
                )}
              />
              <Form.Item className="ui-errorlist">
                <Form.ErrorList errors={errors} />
              </Form.Item>
            </>
          )}
        </Form.List>
      </Col>
    </Row>
  );
};
